export default __webpack_public_path__ + "463efc1ce587fc6046282394ac1d1c23.png";